interface SleepingPlaceItem {
  amenity: {
    name: string
    id: string
  }
  quantity: number
}

export const countSleepingPlaces = <SleepingPlacesType extends SleepingPlaceItem>(
  sleepingPlaces: SleepingPlacesType[] | undefined,
) => {
  if (!sleepingPlaces) return []

  return sleepingPlaces.reduce((acc, sleepingPlace) => {
    const existingPlaceIndex = acc.findIndex(item => item.amenity.id === sleepingPlace.amenity.id)

    if (existingPlaceIndex === -1) {
      return [...acc, { ...sleepingPlace }]
    }

    return acc.map((item, index) =>
      index === existingPlaceIndex
        ? { ...item, quantity: item.quantity + sleepingPlace.quantity }
        : item,
    )
  }, [] as SleepingPlacesType[])
}
